import React, { useContext } from 'react'
import { getPromotionTexts, isPromoMultiTarget } from 'common/utils'
import { getTargetProductId, PromotionBanner, Box, PRICE_PROMOTION_GROUPS } from 'chemistry'
import { getDescriptionLink } from './utils'
import { text } from 'client/fragments/productDetailsFragmentInfo/components/DiscountPercentage'
import { TranslateContext } from 'client/common/translator'
import { getBonusBuysBannerTitleAndDescription } from './getBonusBuysBannerTitleAndDescription'
import { BONUS_BUYS_BANNER_TYPE } from './constants'
const {
  FIXED_PRICE,
  FIXED_PRICE_LOYALTY,
  ABOVE_CART_PRICE,
  ABOVE_CART_PRICE_LOYALTY,
  ABOVE_PRODUCT_PRICE,
  ABOVE_PRODUCT_PRICE_LOYALTY
} = PRICE_PROMOTION_GROUPS

// Bonus Buys logic is described here: https://maxedadiy.atlassian.net/wiki/spaces/IDT/pages/3501555753/Bonus+Buys
export const BonusBuysBanner = ({
  bannerType,
  productDetails,
  discountData: { discount, promotion, isYellow, promotionWithLoyalty },
  lang,
  format
}) => {
  const t = useContext(TranslateContext)

  const isAbovePricePromo = [
    ABOVE_CART_PRICE,
    ABOVE_CART_PRICE_LOYALTY,
    ABOVE_PRODUCT_PRICE,
    ABOVE_PRODUCT_PRICE_LOYALTY
  ].includes(promotion.promotionGroup)

  if (!promotion?.createPromotionCollectionPage && !isAbovePricePromo) return null

  const targetName = promotion?.targetDetails?.name
  const isMultiTarget = isPromoMultiTarget(promotion)
  const { title, description } = getBonusBuysBannerTitleAndDescription({
    bannerType,
    promotion,
    promotionWithLoyalty,
    targetName,
    productDetails,
    amount: promotion.amount,
    isMultiTarget,
    t
  })
  const linkText = promotion?.createPromotionCollectionPage && t('promotions.link_to_collection_page.text')
  const linkHref =
    promotion?.createPromotionCollectionPage &&
    getDescriptionLink(promotion, 'promotions.link_to_collection_page.url', format, lang, t)
  const isFixedPrice = [FIXED_PRICE, FIXED_PRICE_LOYALTY].includes(promotion.promotionGroup)
  const isEuroDiscount = promotion?.discountType === 'EURO'
  return (
    <Box display={isFixedPrice ? 'flex' : 'block'} sx={{ marginY: '32px' }}>
      <PromotionBanner
        isYellow={isYellow}
        promotion={
          bannerType === BONUS_BUYS_BANNER_TYPE.PRICE
            ? { ...promotion, amount: isEuroDiscount ? promotion?.discountValue : discount }
            : promotion
        }
        title={title}
        linkText={linkText}
        linkHref={linkHref}
        description={description}
        linkId='check-promotion-page-link'
        text={text(discount, t)}
        texts={getPromotionTexts(t)}
        showBubble={!isFixedPrice}
        {...(bannerType === BONUS_BUYS_BANNER_TYPE.QUALIFIED &&
        promotion?.targetDetails &&
        promotion?.targetProducts?.length > 0
          ? {
              targetImageLink: promotion?.targetDetails?.image,
              targetProductLink: t('unequal_pdp_discount_product_link', { id: getTargetProductId(promotion) }),
              isMultiTarget
            }
          : {})}
      />
    </Box>
  )
}
